import React from "react";

// Import components
import CsrHero from "../components/CsrHero";
import ProjectShiksha from "../components/ProjectShiksha";
import CsrMission from "../components/CsrMission";
import CsrGallery from "../components/CsrGallery";
import CollaborativeInitiatives from "../components/CollaborativeInitiatives";

// Import data
import { galleryImages } from "../data/galleryData";

const Csr = () => {
  return (
    <>
      <CsrHero />
      {/* <ProjectShiksha /> //Removed In new design */}
      <CsrMission />
      <CollaborativeInitiatives />
      <CsrGallery galleryImages={galleryImages} />
    </>
  );
};

export default Csr;
